import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import green from '@material-ui/core/colors/green';
import Radio from '@material-ui/core/Radio';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  createStyles, WithStyles
} from '@material-ui/core';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import _ from 'lodash';
import { studyActions } from '../../../reducers/notesStateReducers';


const styles = (theme: Theme) => createStyles({
  root: {
    color: green[600],
    '&$checked': {
      color: green[500],
    },
  },
  radioButton: {
    display: 'flex',
  },
  checked: {},
});

interface RadioButtonsProps extends WithStyles<typeof styles> {
  pagekey: any,
  notesData: any,
  handleNotesData: Function,
}
interface RadioButtonsState {
  selectedValue: any,
}

class RadioButtons extends Component<RadioButtonsProps, RadioButtonsState> {
  
  constructor(props: RadioButtonsProps) {
    super(props);
    this.state = {
      selectedValue: {
        ...this.props.notesData.attempt
      },
    };
  }

  handleChange = (event: any) => {
    const { pagekey } = this.props;
    const value = event.target.value === 'true' ? true : false;
    this.setState({
      selectedValue: {
        ...this.props.notesData.attempt,
        [pagekey]: value
      }
    }, ()=> this.props.handleNotesData({ attempt: this.state.selectedValue }));
  };

  render() {
    const { classes, pagekey } = this.props;
    return (
      <div>
        <FormControl >
          <div className={classes.radioButton}>
            <FormControlLabel
              value={this.state.selectedValue[pagekey]}
              control={<Radio
                checked={this.state.selectedValue[pagekey] === true}
                color="primary"
                value={true}
                onChange={this.handleChange}
              />}
              label="Mandatory"
              labelPlacement="end"
            />
            <FormControlLabel
              value={this.state.selectedValue[pagekey]}
              control={<Radio
                checked={this.state.selectedValue[pagekey] === false}
                value={false}
                onChange={this.handleChange}
                color="primary"
              />}
              label="Optional"
              labelPlacement="end"
            />
          </div>
        </FormControl>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {
    notesData: _.get(state, 'studyMaterialReducer')
  }
};
const mapDispatchToProps = (dispatch: any) => bindActionCreators({
  handleNotesData: studyActions.handleNotesData,
}, dispatch);
// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(RadioButtons));